<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">认证权限 /</div>
        <div class="box-header-right"><div>部门管理</div></div>
      </div>
    </div>
    <div class="section" v-if="st == 1">
      <div class="biaodan">
        <div class="botton-box">
          <el-button size="mini" class="addButton" @click="getchildeditDialog"
            >添加</el-button
          >
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="部门名称">
                <el-input
                  v-model="form.deptName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入部门名称"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="部门编码">
                <el-input
                  v-model="form.deptCode"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入部门编码"
                ></el-input>
              </el-form-item> -->
              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onSearch"
                  class="search"
                  size="mini"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  @click="onReset"
                  class="search"
                  size="mini"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="table_name"
              highlight-current-row
              :data="tableData"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center'
              }"
              ref="LoadTable"
              row-class-name="classname"
              row-key="id"
              border
              lazy
              :load="treeLoad"
              @selection-change="handleSelectionChange"
              :tree-props="{ children: 'children', hasChildren: 'haveSon' }"
              max-height="650"
            >
              <!--              <el-table-column-->
              <!--                type="selection"-->
              <!--                width="55">-->
              <!--              </el-table-column>-->
              <el-table-column align="center" prop="deptName" label="部门名称">
                <template slot-scope="scope">
                  <div>{{ scope.row.data.deptName }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column align="center" prop="deptCode" label="部门编码">
                <template slot-scope="scope">
                  <div>{{ scope.row.data.deptCode }}</div>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="createTime"
                label="创建时间"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.createTime }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="360">
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px; color: #3666EA"
                    type="text"
                    @click="getValueDialog(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    style="margin-left: 10px; color: #3666EA"
                    type="text"
                    @click="UserGroupRelation(scope.row)"
                    >成员管理</el-button
                  >
                  <el-popconfirm
                    title="确定删除吗？"
                    trigger="click"
                    @confirm="deleteType(scope.row)"
                  >
                    <el-button
                      style="margin-left: 10px; color: #ed6363"
                      type="text"
                      slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!-- <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div> -->
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="formData"
          :rules="title != '编辑部门信息' ? rules2 : rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item prop="deptName" label="部门名称">
            <el-input
              v-model="formData.deptName"
              placeholder="部门名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item prop="deptCode" label="部门编码">
            <el-input
              v-model="formData.deptCode"
              placeholder="部门编码"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            prop="pid"
            label="上级部门"
            v-if="title != '编辑部门信息'"
            class="tree-d"
          >
            <el-cascader
              :props="props"
              v-model="formData.pid"
              :options="deptTree"
              style="width: 660px"
              @change="handleChange"
              :show-all-levels="false"
              filterable
              clearable
              ref="myCascader"
              :key="cascaderKey"
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="deptOrder" label="排序">
            <el-input
              v-model="formData.deptOrder"
              placeholder="排序"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              maxlength="120"
              show-word-limit
              v-model="formData.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="cancelcerat"
          class="search"
          size="mini"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="成员管理组角色"
      width="800px"
      :modal="true"
      class="user-dialog"
      :close-on-click-modal="false"
      :visible.sync="roleVisible"
    >
      <el-form
        class="guanlian"
        ref="ruleForm"
        :rules="rules"
        :inline="true"
        :model="formPermission"
      >
        <!--        <el-form-item class="data-d"-->
        <!--                      prop="Character"-->
        <!--                      label="角色11111">-->
        <span class="roleLabel">角色：</span>
        <el-transfer
          @change="roleChange"
          v-model="roleValue"
          :data="roleData"
          :titles="['所有角色列表', '授权角色列表']"
        ></el-transfer>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" class="search" size="mini">
          <span @click="setRole">确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="成员管理"
      :close-on-click-modal="false"
      :visible.sync="UserGroupVisible"
    >
      <div class="Group-search">
        <div class="Group-search-input">
          <div style="margin-right: 15px">真实姓名</div>
          <el-input
            style="width: 150px"
            size="mini"
            v-model="UserGroupForm.userName"
            placeholder="真实姓名"
          ></el-input>
          <el-button
            style="margin-left: 15px"
            size="mini"
            type="primary"
            @click="searchUserGroup"
            class="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="Group-button">
        <div></div>
        <!-- <el-button size="mini" type="danger" @click="deleteUserGroup()"
          >删除</el-button
        > -->
        <el-button size="mini" class="addButton" @click="otherGroup()"
          >添加</el-button
        >
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="disTable"
              ref="multipleTable"
              align="center"
              max-height="650"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center'
              }"
              :cell-style="{ textAlign: 'center' }"
              :data="UserGroupList"
              @selection-change="eliminateUserGroup"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                align="center"
                prop="userName"
                label="真实姓名"
                width="200"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="accountName"
                label="登录账号"
              ></el-table-column>
              <el-table-column align="center" prop="phone" label="电话"
                ><template slot-scope="scope">
                  <span>{{ phoneNumbe(scope.row.phone) }}</span>
                </template></el-table-column
              >
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChangeOne"
            layout="total, sizes, prev, pager, next, jumper"
            :total="UserGrouppage.total"
            background
            :page-size="UserGrouppage.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChangeOne"
            :current-page.sync="currentPageOne"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="查询其他用户"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="Group-search">
          <div class="Group-search-input">
            <div style="margin-right: 15px">真实姓名</div>
            <el-input
              style="width: 150px"
              size="mini"
              v-model="UserGroupFormTwo.userName"
              placeholder="真实姓名"
            ></el-input>
            <div style="margin-right: 15px">部门</div>
            <el-cascader
              :props="props"
              v-model="UserGroupFormTwo.deptId"
              :options="deptTree"
              @change="queryhandleChange"
              :show-all-levels="false"
              filterable
              size="mini"
              class="xiugai"
              clearable
            ></el-cascader>
            <el-button
              style="margin-left: 15px"
              size="mini"
              type="primary"
              class="search"
              @click="searchUserOtherGroup"
              >查询</el-button
            >
          </div>
        </div>
        <div class="Group-button">
          <div></div>
          <el-button size="mini" class="addButton" @click="AssociatedUser()"
            >添加</el-button
          >
        </div>
        <div class="aside">
          <el-row>
            <el-col :span="24">
              <el-table
                class="disTable"
                ref="multipleTable"
                align="center"
                max-height="650"
                :header-cell-style="{
                  background: '#F3F8FE',
                  color: '#333333 ',
                  textAlign: 'center'
                }"
                :cell-style="{ textAlign: 'center' }"
                :data="otherGroupList"
                @selection-change="setUserOtherGroup"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  type="index"
                  width="50"
                  label="序号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="userName"
                  label="真实姓名"
                  width="200"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="accountName"
                  label="登录账号"
                ></el-table-column>
                <el-table-column align="center" prop="phone" label="电话">
                  <template slot-scope="scope">
                    <span>{{ phoneNumbe(scope.row.phone) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChangeTwo"
              layout="total, sizes, prev, pager, next, jumper"
              :total="UserGroupotherpage.total"
              background
              :page-size="UserGroupotherpage.size"
              :page-sizes="[10, 50, 100, 200]"
              @size-change="handleSizeChangeTwo"
              :current-page.sync="currentPageTwo"
              :style="{ textAlign: 'right', marginTop: '20px' }"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDeptTreet,
  setDeptSave,
  getRoleArray,
  UserSwitch,
  getDeptTree,
  setDdeptRole,
  getDeptUser,
  getDeptOtherUser,
  getDeptDeleteUser,
  getDeptAddUser,
  getUserList
} from "@/api/systemManagement";
import { getDeptQuery, getDeptRoot } from "../../../api/systemManagement";
export default {
  data() {
    const _self = this;
    return {
      visible: false,
      deptTree: [],
      roleValue: [],
      UserGroupList: [],
      UserGroupForm: {
        id: null,
        userName: ""
      },
      cascaderKey: 1,
      UserOtherGroupList: [],
      otherGroupList: [],
      innerVisible: false,
      DepartmentList: [],
      tableDataTwo: [],
      roleList: [],
      roleData: [],
      roleVisible: false,
      UserGroupVisible: false,
      dialogVisibleTwo: false,
      currentPageTwo: 1,
      currentPageOne: 1,
      UserGroupRelationUser: false,
      dialogVisible: false,
      passwordVisible: false,
      st: 1,
      formPermission: {
        id: null,
        roleIds: []
      },
      totalTwo: "",
      statusOptions: [
        {
          dictValue: "",
          dictLabel: "全部"
        },
        {
          dictValue: 1,
          dictLabel: "正常"
        },
        {
          dictValue: 2,
          dictLabel: "停用"
        }
      ],
      userTypeList: [
        { value: 1, label: "B端用户" },
        { value: 2, label: "C端用户" }
      ],
      UserGroupFormTwo: {
        userName: "",
        deptId: null
      },
      ruleForm: {
        accountName: "",
        userName: "",
        password: "",
        deptId: "",
        userType: 1,
        phone: "",
        idNo: null,
        email: "",
        jobinfo: "",
        status: 1,
        id: ""
      },
      passwordForm: {
        newPassword: "",
        old: "",
        towPassword: ""
      },
      entryList: [],
      optionList: [],
      total: null,
      title: "添加部门",
      titleTwo: "查看配置基本信息",
      currentPage: 1,
      form: {
        deptName: "",
        deptCode: ""
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        remark: "",
        deptName: "",
        deptCode: "",
        pid: "",
        id: null,
        deptOrder: null
      },
      SelectUserGroup: [],
      viewFormData: {
        status: null,
        accountName: null,
        userName: null,
        password: null,
        deptId: null,
        mail: null,
        idNo: null,
        phone: null,
        userType: null,
        jobinfo: null
      },
      UserGrouppage: {
        page: 1,
        size: 10,
        total: 0
      },
      isShearch: true,
      UserGroupotherpage: {
        page: 1,
        size: 10,
        total: 0
      },
      choiceList: [],
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" }
        ]
      },
      rules2: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" }
        ],
        pid: [{ required: true, message: "请选择上级部门", trigger: "blur" }]
      },
      maps: new Map(),
      props: {
        value: "id",
        label: "label",
        children: "children",
        hasChildren: "haveSon",
        checkStrictly: true,
        lazy: true, //设置lazyLoad，必须配合lazy：true
        async lazyLoad(node, resolve) {
          // 区域树懒加载的方法
          const { data } = node;
          if (
            (data && data.haveSon === false) ||
            (data && data.leaf === true)
          ) {
            return resolve([]);
          }
          let id;
          if (data) {
            id = data.id;
          } else {
            return resolve([]);
          }
          const temp = await _self.getSta(id);
          for (const item of temp.data) {
            item.leaf = item.level === "city";
          }
          resolve(temp.data);
        }
      }
    };
  },
  mounted() {
    this.queryDictionaries();
    this.st = 1;
    this.getrole();
    this.getTree();
    window.addEventListener("setItem", () => {
      this.queryDictionaries();
    });
  },
  computed: {
    phoneNumbe() {
      return function(phone) {
        if (!phone) return;
        // 手机号仅显示前三位及后四位数字，隐藏信息用*代替
        return phone.substr(0, 3) + "****" + phone.substring(7);
      };
    }
  },
  watch: {
    innerVisible(val) {
      if (val == false) {
        this.searchUserGroup();
      }
    },
    UserGroupVisible(val) {
      if (val == false) {
        this.UserGroupForm.userName = "";
      }
    }
  },
  methods: {
    searchUserOtherGroup() {
      this.otherGroup();
    },
    setUserOtherGroup(val) {
      this.UserOtherGroupList = [];
      val.map(item => {
        this.UserOtherGroupList.push(item.id);
      });
    },
    async AssociatedUser() {
      if (!this.UserOtherGroupList.length) {
        this.$message({
          message: "请勾选用户信息",
          type: "warning"
        });
        return false;
      }
      let params = {
        id: this.UserGroupForm.id,
        userIds: this.UserOtherGroupList
      };
      const res = await getDeptAddUser(params);
      if (res.data.code == 200) {
        this.$message({
          message: "用户组添加用户成功",
          type: "success"
        });
        this.otherGroup();
      }
    },
    async searchUserGroup() {
      let params = {
        id: this.UserGroupForm.id,
        userName: this.UserGroupForm.userName,
        size: this.UserGrouppage.size,
        page: this.UserGrouppage.page
      };
      const res = await getDeptUser(params);
      if (res.data.code == 200) {
        this.UserGroupList = res.data.data.dataList;
        this.UserGrouppage.total = Number(res.data.data.total) || 0;
      }
    },
    eliminateUserGroup(val) {
      this.SelectUserGroup = [];
      val.map(item => {
        this.SelectUserGroup.push(item.id);
      });
    },
    async deleteUserGroup() {
      if (!this.SelectUserGroup.length) {
        this.$message({
          message: "请勾选用户信息",
          type: "warning"
        });
        return false;
      }
      let params = {
        id: this.UserGroupForm.id,
        userIds: this.SelectUserGroup
      };
      const res = await getDeptDeleteUser(params);
      if (res.data.code == 200) {
        this.$message({
          message: "用户组去除用户成功",
          type: "success"
        });
        this.searchUserGroup();
      }
    },
    queryhandleChange(val) {
      this.UserGroupFormTwo.deptId = val[val.length - 1];
    },
    async otherGroup() {
      let params = {
        // deptId: this.UserGroupForm.id,
        userName: this.UserGroupFormTwo.userName,
        deptId: this.UserGroupFormTwo.deptId,
        page: this.UserGroupotherpage.page,
        size: this.UserGroupotherpage.size
      };
      // const res = await getDeptOtherUser(params);
      const res = await getUserList(params);
      if (res.data.code == 200) {
        this.otherGroupList = res.data.data.dataList;
        this.UserGroupotherpage.total = Number(res.data.data.total);
      }
      this.innerVisible = true;
    },
    roleChange(val) {
      this.formPermission.roleIds = val;
    },
    async UserGroupRelation(val) {
      this.UserGroupForm.id = val.id;
      let params = {
        id: val.id,
        name: this.UserGroupForm.name
      };
      const res = await getDeptUser(params);
      if (res.data.code == 200) {
        this.UserGroupList = res.data.data.dataList;
        this.UserGrouppage.total = Number(res.data.data.total) || 0;
      }
      this.UserGroupVisible = true;
    },
    rolerelation(val) {
      this.roleValue = [];
      this.$axios.get(`/role/dept/${val.id}`).then(res => {
        if (res.data.code == 200) {
          this.$nextTick(item => {
            res.data.data.map(item => {
              this.roleValue.push(item.id);
            });
          });
        }
      });
      this.formPermission.id = val.id;
      this.roleVisible = true;
    },
    async setRole() {
      let params = {
        id: this.formPermission.id,
        roleIds: this.formPermission.roleIds
      };
      const res = await setDdeptRole(params);
      if (res.data.code == 200) {
        this.$message({
          message: "成员管理信息成功",
          type: "success"
        });
        this.roleVisible = false;
      }
    },
    resetPassword(val) {
      this.passwordVisible = true;
    },
    handleChange(val) {
      this.formData.pid = val[val.length - 1];
    },
    handleSelectionChange(val) {
      this.choiceList = val;
    },
    // 获取部门资源树形
    async getTree() {
      let params = {
        name: "",
        id: "",
        deptCode:
          JSON.parse(sessionStorage.getItem("userInfo")) &&
          JSON.parse(sessionStorage.getItem("userInfo")).detpCode
        // deptCode: '440326003009',
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptTree = res.data.data;
        if (this.deptTree.length) this.deptTree[0].haveSon = true;
      }
    },
    async getSta(pid) {
      const params = {
        name: "",
        id: "",
        pid: pid
      };
      const data = await getDeptTree(params);
      return data.data;
    },
    // 获取部门资源树形
    async getTrees(par) {
      let params = {
        name: "",
        id: "",
        excludeId: par
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptTree = res.data.data;
      }
    },
    // 启用
    async enableUser() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 1
      };
      const res = await UserSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "禁用成功",
          type: "success"
        });
        this.onSearch();
      }
    },
    // 禁用用户
    async disableUser() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 2
      };
      const res = await UserSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "禁用成功",
          type: "success"
        });
        this.onSearch();
      }
    },
    // 查询部门下拉列表
    // 查询角色下拉列表
    async getrole() {
      const res = await getRoleArray();
      if (res.data.code == 200) {
        res.data.data.map(item => {
          this.roleData.push({ label: item.value, key: item.id });
        });
      }
    },
    GetUser(val) {
      this.viewFormData.status = val.status;
      this.viewFormData.accountName = val.accountName;
      this.viewFormData.userName = val.userName;
      this.viewFormData.password = val.password;
      this.viewFormData.deptId = val.deptId;
      this.viewFormData.mail = val.mail;
      this.viewFormData.idNo = val.idNo;
      this.viewFormData.phone = val.phone;
      this.viewFormData.userType = val.userType;
      this.viewFormData.jobinfo = val.jobinfo;
      this.visible = true;
    },
    async getValueDialog(val) {
      this.dialogVisible = true;
      this.title = "编辑部门信息";
      this.formData.deptCode = val.data.deptCode;
      this.formData.deptName = val.data.deptName;
      this.formData.remark = val.data.remark;
      this.formData.pid = val.data.pid;
      this.formData.id = val.data.id;
      this.formData.deptOrder = val.data.deptOrder;
      this.getTrees(val.data.id);
    },
    // 删除用户
    async deleteType(val) {
      if ((this.total - 1) % this.page.size === 0) {
        if (this.page.page > 1) {
          this.page.page -= 1;
        }
      }
      this.$axios
        .delete(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/dept/delete/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            if (val.pid != -1) {
              let { tree, treeNode, resolve } = this.maps.get(val.pid);
              this.$set(
                this.$refs.LoadTable.store.states.lazyTreeNodeMap,
                val.pid,
                []
              );
              if (tree) {
                this.treeLoad(tree, treeNode, resolve);
              }
            } else {
              this.queryDictionaries();
            }
          } else {
            this.$message({
              message: `${res.data.msg}`,
              type: "warning"
            });
          }
        });
    },
    async cancelcerat() {
      if (this.formData.deptName == null || this.formData.deptName == "") {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      if (!!!this.formData.pid && this.title != "编辑部门信息") {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        deptCode: this.formData.deptCode,
        deptName: this.formData.deptName,
        pid: this.formData.pid,
        remark: this.formData.remark,
        id: this.formData.id,
        deptOrder: Number(this.formData.deptOrder)
      };
      const res = await setDeptSave(params);
      if (res.data.code == 200) {
        if (this.formData.pid != -1) {
          if (this.maps.get(this.formData.pid) !== undefined) {
            if (this.formData.pid) {
              let { tree, treeNode, resolve } = this.maps.get(
                this.formData.pid
              );
              this.$set(
                this.$refs.LoadTable.store.states.lazyTreeNodeMap,
                this.formData.pid,
                []
              );
              if (tree) {
                this.treeLoad(tree, treeNode, resolve);
              }
            }
          }
        }
        this.formData.deptCode = null;
        this.formData.deptName = 1;
        this.formData.id = null;
        this.formData.pid = null;
        this.formData.remark = "";
        this.queryDictionaries();
        this.dialogVisible = false;
        this.$message({
          message: "保存成功",
          type: "success"
        });
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    getchildeditDialog() {
      this.getTree();
      this.title = "新增部门";
      this.formData.deptCode = "";
      this.formData.deptName = "";
      this.formData.remark = "";
      this.formData.pid = null;
      this.formData.id = null;
      this.formData.deptOrder = null;
      this.dialogVisible = true;
    },
    getchildeditDialogTwo() {
      this.ruleFormTwo.itemLabel = "";
      this.ruleFormTwo.itemName = "";
      this.ruleFormTwo.status = 1;
      this.ruleFormTwo.remark = "";
      this.ruleFormTwo.id = "";
      this.titleTwo = "添加字典项数据";
      this.ruleFormTwo.dictType = this.formData.dictType;
      this.dialogVisibleTwo = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    handleCurrentChange(val) {
      this.page.page = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    handleSizeChangeOne(val) {
      this.UserGrouppage.size = val;
      this.searchUserGroup();
    },
    handleCurrentChangeOne(val) {
      this.UserGrouppage.page = val;
      this.searchUserGroup();
    },
    handleSizeChangeTwo(val) {
      this.UserGroupotherpage.size = val;
      this.otherGroup();
    },
    handleCurrentChangeTwo(val) {
      this.UserGroupotherpage.page = val;
      this.otherGroup();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.isShearch = false;
      this.queryDictionaries("search");
    },
    // 重置
    onReset() {
      this.form.deptCode = "";
      this.form.deptName = "";
      this.page.page = 1;
      this.page.size = 10;
      this.currentPage = 1;
      this.isShearch = true;
      this.queryDictionaries();
    },
    // 查询用户列表
    async queryDictionaries() {
      let params = {
        page: this.page.page,
        size: this.page.size,
        data: true
      };
      let deptCode = "";
      if (
        sessionStorage.getItem("userInfo") &&
        sessionStorage.getItem("userInfo").length > 2
      ) {
        deptCode = JSON.parse(sessionStorage.getItem("userInfo")).detpCode;
      }
      if (this.form.deptName) {
        params.deptName = this.form.deptName;
      } else {
        params.deptCode = deptCode;
      }
      const res = await getDeptRoot(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        if (this.tableData.length) this.tableData[0].haveSon = true;
        // this.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    async treeLoad(tree, treeNode, resolve) {
      let params = {
        page: this.page.page,
        size: this.page.size,
        data: true,
        pid: tree.id
      };
      const res = await getDeptTreet(params);
      this.maps.set(tree.id, { tree, treeNode, resolve });
      return resolve(res.data.data);
    }
  }
};
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}
.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
}
.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #b2b3c9;
  line-height: 21px;
  display: flex;
  align-items: center;
}
.box-header-right {
  font-weight: 400;
  color: #004ad1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
.section {
  height: 94.9%;
  background-color: #fff;
}
.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}
.el-menu-item:hover {
  color: #1e90ff;
}
.daohang {
  display: flex;
  margin-left: 15px;
}
.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}
.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  .form-item {
    padding: 0;
    margin: 0;
  }
}
.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.biaodan-left .el-form-item {
  margin-bottom: 0px;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}
.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}
/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}
.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  justify-content: left;
}
.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}
.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}
.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
.passWordForm {
  .el-form-item__content {
    width: 70%;
    display: flex !important;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -43px;
    margin-left: 95px;
  }
}

.updatePassword {
  width: 70px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #0495ff;
  border-radius: 10%;
}
#character {
  .el-dialog {
    height: 860px;
    overflow: scroll;
  }

  .el-form-item__label {
    width: 95px;
  }

  .Permission_form {
    display: flex;
    justify-content: space-around;
    .roleLabel {
      color: #606266;
      font-size: 14px;
      font-weight: 800;
    }
    .el-form-item__content {
      width: 78.5%;
      height: 45px;
    }
  }

  .div-tag {
    width: auto;
    display: inline-block;
    position: relative;
    bottom: 41px;
    left: 4px;
    height: 40px;
    max-width: 450px;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .character .el-dialog__body .data-d {
    height: 345px;
  }
  .pass {
    .el-dialog {
      margin-top: 33vh !important;
      width: 23% !important;
      height: 433px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}
/deep/.v-modal {
  z-index: 2000 !important;
}
.user-dialog {
  .el-form-item {
    margin-bottom: 10px;
    width: 45% !important;
  }
}
.character .el-dialog__body form {
  padding-bottom: 0;
}
.tree-option {
  height: auto;
}
.tree-class .el-tree-node__content {
  &:hover {
    background-color: #dfeafb;
  }
}
.el-message {
  z-index: 2222 !important;
}
.tree-d {
  .el-form-item__content {
    position: relative;
    & > .el-input {
      position: absolute;
      z-index: 2;
    }
  }
}
.word {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    margin-left: 25px;
  }
}
.guanlian {
  margin-left: 88px;
}
.demo-ruleForm {
  margin-left: 100px;
}
.Group-search {
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center;
  .Group-search-input {
    display: flex;
    align-items: center;
  }
}
.Group-button {
  height: 70px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
///deep/.table_name .cell{
//  display: flex;
//  //align-items: center;
//  //height: 30px;
//  //text-align: center;
//}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(1) .cell {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(1) {
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/departmentManagement/index.vue